import type { Resolver } from 'cpool-schemas';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    phone: string;
};

export const schemaLoanRequestResolver_FindIdsByPhone = z.array(schemaId);

export type SchemaLoanRequestResolver_FindIdsByPhone = z.infer<typeof schemaLoanRequestResolver_FindIdsByPhone>;

export type LoanRequestResolver_FindIdsByPhone = Resolver<Arguments, SchemaLoanRequestResolver_FindIdsByPhone>;
